import React, { useState, useEffect } from "react";
import { Calendar, Clock, MapPin, Users, ArrowUpRightIcon } from "lucide-react";
import { Link } from "react-router-dom";

export default function EventsUpcoming({ onRegisterClick }) {
    const targetDate = new Date("2026-12-28T15:00:00Z").getTime();

    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });

    useEffect(() => {
        const timer = setInterval(() => {
            const now = new Date().getTime();
            const difference = targetDate - now;

            if (difference > 0) {
                setTimeLeft({
                    days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                    hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                    minutes: Math.floor((difference / 1000 / 60) % 60),
                    seconds: Math.floor((difference / 1000) % 60),
                });
            } else {
                clearInterval(timer);
            }
        }, 1000);

        return () => clearInterval(timer);
    }, [targetDate]);

    return (
        <section className="relative overflow-hidden pt-12 pb-16 px-4 md:px-12 bg-[#000036] text-white">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[300px] bg-blue-600/15 blur-[120px] pointer-events-none rounded-full" />
            <div className="max-w-6xl mx-auto relative z-10 space-y-12">
                <div className="flex flex-col items-center text-center max-w-3xl mx-auto mb-20">
                    <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full  backdrop-blur-md mb-4">
                        <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-white">
                            upocoming events
                        </span>
                    </div>
                    <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-white">
                        Learn, Build & Orchestrate at{" "}
                        <span className="italic font-serif font-normal text-[#62d4f7]">
                            Enterprise Scale
                        </span>{" "}
                    </h2>
                    <p className="mt-5 text-base sm:text-lg text-white leading-relaxed max-w-2xl">
                        Deep-dive masterclasses, architecture breakdowns, and hands-on labs with leading engineers building autonomous AI workflows.
                    </p>
                </div>
                <div className="bg-[#132238]/90 border border-white/10 rounded-3xl p-6 md:p-10 shadow-2xl backdrop-blur-md relative overflow-hidden">
                    <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-500 via-indigo-500 to-cyan-400" />
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
                        <div className="lg:col-span-7 space-y-5">
                            <div className="flex flex-wrap items-center gap-2.5">
                                <span className="flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold bg-red-500/20 border border-red-500/30 text-red-300">
                                    <span className="w-2 h-2 rounded-full bg-red-400 animate-pulse" />
                                    Next Live Lab
                                </span>
                                <span className="px-3 py-1 rounded-full text-xs font-medium bg-blue-500/10 text-blue-300 border border-blue-400/20">
                                    Virtual Hands-on
                                </span>
                            </div>
                            <h2 className="text-2xl md:text-3xl font-extrabold text-white leading-snug">
                                Building Fault-Tolerant Zeebe Micro-Workers for Real-Time LLM Pipelines
                            </h2>
                            <p className="text-gray-300 text-sm md:text-base leading-relaxed">
                                Join our systems architects to learn how Camunda 8 boundary events and deterministic DMN gates isolate autonomous AI agents to eliminate systemic hallucination risks.
                            </p>
                            {/* Event Metadata row */}
                            <div className="flex flex-wrap gap-4 text-xs md:text-sm text-gray-300 pt-2 border-t border-white/10">
                                <div className="flex items-center gap-1.5">
                                    <Calendar className="w-4 h-4 text-blue-400" />
                                    <span>December 28, 2026</span>
                                </div>
                                <div className="flex items-center gap-1.5">
                                    <Clock className="w-4 h-4 text-blue-400" />
                                    <span>11:00 AM EST (60 Mins)</span>
                                </div>
                                <div className="flex items-center gap-1.5">
                                    <MapPin className="w-4 h-4 text-blue-400" />
                                    <span>Interactive Zoom Live</span>
                                </div>
                            </div>
                            {/* Speaker info */}
                            <div className="flex items-center gap-3 pt-2">
                                <div className="w-10 h-10 rounded-full bg-gradient-to-tr from-blue-600 to-indigo-400 flex items-center justify-center font-bold text-white shadow-md">
                                    TS
                                </div>
                                <div>
                                    <div className="text-sm font-bold text-white">Truviq System</div>
                                    <div className="text-xs text-gray-400">Principal Systems Architect, Truviq</div>
                                </div>
                            </div>
                        </div>
                        <div className="lg:col-span-5 flex flex-col justify-center items-center  border border-white/10 rounded-2xl p-6 md:p-8 text-center space-y-6">
                            <div>
                                <span className="text-xs uppercase tracking-wider text-gray-400 font-semibold block mb-3">
                                    Registration Closes In
                                </span>
                                <div className="grid grid-cols-4 gap-2">
                                    <div className="bg-[#15243B] p-2.5 rounded-xl border border-white/5">
                                        <div className="text-2xl font-black text-white">{timeLeft.days}</div>
                                        <div className="text-[10px] text-gray-400 uppercase">Days</div>
                                    </div>
                                    <div className="bg-[#15243B] p-2.5 rounded-xl border border-white/5">
                                        <div className="text-2xl font-black text-white">{timeLeft.hours}</div>
                                        <div className="text-[10px] text-gray-400 uppercase">Hours</div>
                                    </div>
                                    <div className="bg-[#15243B] p-2.5 rounded-xl border border-white/5">
                                        <div className="text-2xl font-black text-white">{timeLeft.minutes}</div>
                                        <div className="text-[10px] text-gray-400 uppercase">Mins</div>
                                    </div>
                                    <div className="bg-[#15243B] p-2.5 rounded-xl border border-white/5">
                                        <div className="text-2xl font-black text-white">{timeLeft.seconds}</div>
                                        <div className="text-[10px] text-gray-400 uppercase">Secs</div>
                                    </div>
                                </div>
                            </div>
                            <div className="w-full space-y-3">
                                <Link
                                    to="/contact"
                                    className="group relative inline-flex items-center justify-between rounded-full gap-3 px-6 py-2 border border-black/15 bg-[#ffffff] text-[#000036] font-mono text-sm font-semibold capitalize tracking-widest transition-all duration-300 hover:bg-white hover:text-slate-700 hover:shadow-lg"
                                >
                                    <span>Reserve Your Free Seat</span>
                                    <div className="h-7 w-7 rounded-full bg-white/10 flex items-center justify-center transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-0.5 group-hover:bg-slate-700 group-hover:text-white">
                                        <ArrowUpRightIcon size={15} />
                                    </div>
                                </Link>

                                <div className="flex items-center justify-center gap-1.5 text-[12px] tracking-wider text-white">
                                    <Users className="w-4.5 h-4.5 text-white" />
                                    <span>340+ Engineers & Architects already registered</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}